import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { UserDetails } from '@/hooks/queries/use-get-user-detail.query';

type UserState = {
  user: UserDetails | null;
  setUser: (user: UserDetails | null) => void;
  clearUser: () => void;
};

export const useUserStore = create<UserState>()(
  devtools(
    set => ({
      user: null,
      setUser: user => set({ user }),
      clearUser: () => set({ user: null }),
    }),
    { name: 'UserStore' }
  )
);
